import { ApplicationRootState } from 'types';
import { createSelector } from 'reselect';

/**
 * Direct selector to the app state domain
 */

const selectConfiguratorDomain = (state: ApplicationRootState) =>
  state.configurator || null;

const makeSelectProgressLoadingConfigurator = () =>
  createSelector(selectConfiguratorDomain, substate => {
    let progress = 0;
    if (substate) {
      if (substate.furniture && substate.furniture.furniture !== null)
        progress += 20;
      if (substate.colors && substate.colors.data !== null) progress += 10;
      if (substate.rules && substate.rules.data !== null) progress += 10;
      if (substate.pieces && substate.pieces.data !== null) progress += 60;
    }

    return progress;
  });

const makeSelectIsConfiguratorReady = () =>
  createSelector(
    makeSelectProgressLoadingConfigurator(),
    (progress): boolean => progress === 100,
  );

export { makeSelectIsConfiguratorReady };
